// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__6Tq+b","rotate":"Spinner_rotate__QhLYt","prixClipFix":"Spinner_prixClipFix__hYnAj"};